import { Link } from "react-router";
import ImageWithBasePath from "../image-with-base-path";
import { all_routes } from "@/routes/all_routes";

const CustomFooter = () => {
  return (
    <>
      {/* Footer Section */}
      <footer className="footer inner-footer">
        <div className="footer-top">
          <div className="container">
            <div className="row">
              <div className="col-xl-8">
                <div className="row">
                  <div className="col-lg-3 col-md-3 col-sm-6">
                    <div className="footer-widget footer-menu">
                      <h6 className="footer-title">Company</h6>
                      <ul>
                        <li>
                          <Link to={all_routes.aboutUs}>About</Link>
                        </li>
                        <li>
                          <Link to={all_routes.search1}>Features</Link>
                        </li>
                        <li>
                          <Link to="#">Works</Link>
                        </li>
                        <li>
                          <Link to="#">Careers</Link>
                        </li>
                        <li>
                          <Link to={all_routes.contactUs}>Locations</Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-3 col-sm-6">
                    <div className="footer-widget footer-menu">
                      <h6 className="footer-title">Treatments</h6>
                      <ul>
                        <li>
                          <Link to={all_routes.search1}>Dental</Link>
                        </li>
                        <li>
                          <Link to={all_routes.search1}>Cardiac</Link>
                        </li>
                        <li>
                          <Link to={all_routes.search1}>Spinal Cord</Link>
                        </li>
                        <li>
                          <Link to={all_routes.search1}>Hair Growth</Link>
                        </li>
                        <li>
                          <Link to={all_routes.search1}>
                            Anemia &amp; Disorder
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-3 col-sm-6">
                    <div className="footer-widget footer-menu">
                      <h6 className="footer-title">Specialities</h6>
                      <ul>
                        <li>
                          <Link to={all_routes.search1}>Transplant</Link>
                        </li>
                        <li>
                          <Link to={all_routes.search1}>Cardiologist</Link>
                        </li>
                        <li>
                          <Link to={all_routes.search1}>Oncology</Link>
                        </li>
                        <li>
                          <Link to={all_routes.search1}>Pediatrics</Link>
                        </li>
                        <li>
                          <Link to={all_routes.search1}>Gynacology</Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-3 col-sm-6">
                    <div className="footer-widget footer-menu">
                      <h6 className="footer-title">Utilites</h6>
                      <ul>
                        <li>
                          <Link to={all_routes.pricing}>Pricing</Link>
                        </li>
                        <li>
                          <Link to={all_routes.contactUs}>Contact</Link>
                        </li>
                        <li>
                          <Link to={all_routes.contactUs}>Request A Quote</Link>
                        </li>
                        <li>
                          <Link to="#">Premium Membership</Link>
                        </li>
                        <li>
                          <Link to="#">Integrations</Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-4 col-md-7">
                <div className="footer-widget">
                  <h6 className="footer-title">Newsletter</h6>
                  <p className="mb-2 text-dark">
                    Subscribe &amp; Stay Updated from the Doccure
                  </p>
                  <div className="subscribe-input">
                    <form action="#">
                      <input
                        type="email"
                        className="form-control"
                        placeholder="Enter Email Address"
                      />
                      <button
                        type="submit"
                        className="btn btn-md btn-primary-gradient d-inline-flex align-items-center"
                      >
                        <i className="isax isax-send-25 me-1" />
                        Send
                      </button>
                    </form>
                  </div>
                  <div className="social-icon">
                    <h6 className="mb-3 footer-title">Connect With Us</h6>
                    <ul>
                      <li>
                        <Link to="#">
                          <i className="fa-brands fa-facebook" />
                        </Link>
                      </li>
                      <li>
                        <Link to="#">
                          <i className="fa-brands fa-x-twitter" />
                        </Link>
                      </li>
                      <li>
                        <Link to="#">
                          <i className="fa-brands fa-instagram" />
                        </Link>
                      </li>
                      <li>
                        <Link to="#">
                          <i className="fa-brands fa-linkedin" />
                        </Link>
                      </li>
                      <li>
                        <Link to="#">
                          <i className="fa-brands fa-pinterest" />
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <div className="container">
            {/* Copyright */}
            <div className="copyright">
              <div className="copyright-text mb-0">
                <p className="mb-0">
                  Copyright © 2026 Doccure. All Rights Reserved
                </p>
              </div>
              {/* Copyright Menu */}
              <div className="copyright-menu">
                <ul className="policy-menu mb-0">
                  <li>
                    <Link to="#">Legal Notice</Link>
                  </li>
                  <li>
                    <Link to={all_routes.privacyPolicy}>Privacy Policy</Link>
                  </li>
                  <li>
                    <Link to="#">Refund Policy</Link>
                  </li>
                </ul>
              </div>
              {/* /Copyright Menu */}
              <ul className="payment-method">
                <li>
                  <Link to="#">
                    <ImageWithBasePath
                      src="assets/img/icons/card-01.svg"
                      alt="Img"
                    />
                  </Link>
                </li>
                <li>
                  <Link to="#">
                    <ImageWithBasePath
                      src="assets/img/icons/card-02.svg"
                      alt="Img"
                    />
                  </Link>
                </li>
                <li>
                  <Link to="#">
                    <ImageWithBasePath
                      src="assets/img/icons/card-03.svg"
                      alt="Img"
                    />
                  </Link>
                </li>
                <li>
                  <Link to="#">
                    <ImageWithBasePath
                      src="assets/img/icons/card-04.svg"
                      alt="Img"
                    />
                  </Link>
                </li>
                <li>
                  <Link to="#">
                    <ImageWithBasePath
                      src="assets/img/icons/card-05.svg"
                      alt="Img"
                    />
                  </Link>
                </li>
                <li>
                  <Link to="#">
                    <ImageWithBasePath
                      src="assets/img/icons/card-06.svg"
                      alt="Img"
                    />
                  </Link>
                </li>
              </ul>
            </div>
            {/* /Copyright */}
          </div>
        </div>
      </footer>
      {/* /Footer Section */}
    </>
  );
};

export default CustomFooter;
